//////////////////////////////

// questo schema è utilizzato dal frontend
// per generare la maschera di ricerca delle keywords

//////////////////////////////

module.exports = (type) => {
    var schema = {

        label: {
            type: type.STRING(2048),
            allowNull: true,
        },
        rwcompany_id: {
            type: type.INTEGER,
            allowNull: true,
            references: {
                model       : 'rwcompanies',
                key         : 'id',
                constraints : true,
                store_name  : 'rwcompany',
            }
        },

    };

    return schema;
}



